import type { Alert } from '../../types';

export function getAlertStatusColor(
  status: Alert['status']
): 'success' | 'error' | 'info' | 'default' {
  switch (status) {
    case 'resolved':
      return 'success';
    case 'active':
      return 'error';
    case 'acknowledged':
      return 'info';
    default:
      return 'default';
  }
}
